/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateVectorStoreFileAttributesRequestAttributes =
  | string
  | boolean
  | number;

/**
 * Request body for updating vector store file attributes.
 */
export type UpdateVectorStoreFileAttributesRequest = {
  /**
   * Set of 16 key-value pairs that can be attached to an object. Keys are strings with a maximum length of 64 characters. Values are strings with a maximum length of 512 characters, booleans, or numbers.
   */
  attributes: { [k: string]: string | boolean | number };
};

/** @internal */
export const UpdateVectorStoreFileAttributesRequestAttributes$inboundSchema:
  z.ZodType<
    UpdateVectorStoreFileAttributesRequestAttributes,
    z.ZodTypeDef,
    unknown
  > = z.union([z.string(), z.boolean(), z.number()]);
/** @internal */
export type UpdateVectorStoreFileAttributesRequestAttributes$Outbound =
  | string
  | boolean
  | number;

/** @internal */
export const UpdateVectorStoreFileAttributesRequestAttributes$outboundSchema:
  z.ZodType<
    UpdateVectorStoreFileAttributesRequestAttributes$Outbound,
    z.ZodTypeDef,
    UpdateVectorStoreFileAttributesRequestAttributes
  > = z.union([z.string(), z.boolean(), z.number()]);

export function updateVectorStoreFileAttributesRequestAttributesToJSON(
  updateVectorStoreFileAttributesRequestAttributes:
    UpdateVectorStoreFileAttributesRequestAttributes,
): string {
  return JSON.stringify(
    UpdateVectorStoreFileAttributesRequestAttributes$outboundSchema.parse(
      updateVectorStoreFileAttributesRequestAttributes,
    ),
  );
}
export function updateVectorStoreFileAttributesRequestAttributesFromJSON(
  jsonString: string,
): SafeParseResult<
  UpdateVectorStoreFileAttributesRequestAttributes,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      UpdateVectorStoreFileAttributesRequestAttributes$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'UpdateVectorStoreFileAttributesRequestAttributes' from JSON`,
  );
}

/** @internal */
export const UpdateVectorStoreFileAttributesRequest$inboundSchema: z.ZodType<
  UpdateVectorStoreFileAttributesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  attributes: z.record(z.union([z.string(), z.boolean(), z.number()])),
});
/** @internal */
export type UpdateVectorStoreFileAttributesRequest$Outbound = {
  attributes: { [k: string]: string | boolean | number };
};

/** @internal */
export const UpdateVectorStoreFileAttributesRequest$outboundSchema: z.ZodType<
  UpdateVectorStoreFileAttributesRequest$Outbound,
  z.ZodTypeDef,
  UpdateVectorStoreFileAttributesRequest
> = z.object({
  attributes: z.record(z.union([z.string(), z.boolean(), z.number()])),
});

export function updateVectorStoreFileAttributesRequestToJSON(
  updateVectorStoreFileAttributesRequest:
    UpdateVectorStoreFileAttributesRequest,
): string {
  return JSON.stringify(
    UpdateVectorStoreFileAttributesRequest$outboundSchema.parse(
      updateVectorStoreFileAttributesRequest,
    ),
  );
}
export function updateVectorStoreFileAttributesRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateVectorStoreFileAttributesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      UpdateVectorStoreFileAttributesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateVectorStoreFileAttributesRequest' from JSON`,
  );
}
